<template>
  <div class="header-nologin">
    <div class="nologin-title">你与搜货只有一步之遥</div>
    <button class="login-btn" @click="goRegister">登录/注册</button>
  </div>
</template>

<script>
export default {
  methods: {
    goRegister () {
      this.$emit('goRegister')
    }
  }
}
</script>

<style scoped>
  .header-nologin{
    padding: 5% 4%;
    color: #fff;
    font-size: 16px;
    box-sizing: border-box;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content: center;
    background: #000;
  }
  .nologin-title{
    color: #fff;
    font-size: 16px;
  }
  .login-btn{
    background: #fff;
    color: #000;
    font-size: 14px;
    height: 2.2em;
    padding: 0 1.5em;
    border: none;
    border-radius: 5px;
    margin-top: 0.5em;
  }
</style>
